import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Badge, Button, ButtonGroup, CloseButton, Col, Container, FloatingLabel, Form, Image, Row, Tab, Tabs, ToggleButton } from 'react-bootstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { LoginInfo } from '../App.js';
import Birthday from '../domain/Birthday.ts';
import Email from '../domain/Email.js';
import HomePage from '../domain/HomePage.js';
import InstagramId from '../domain/InstagramId.js';
import Password from '../domain/Password.js';
import ProfileImage from '../domain/ProfileImage.js';
import SelfIntroduction from '../domain/SelfIntroduction.js';
import Sex from '../domain/Sex.js';
import TwitterId from '../domain/TwitterId.js';
import UserId from '../domain/UserId.js';
import UserInfo from '../domain/UserInfo.ts';
import AiWorksDisplayFlag from '../domain/R18DisplayFlag.js'
import UserName from '../domain/UserName.js';
import * as ImageUtil from '../service/ImageUtil.js';
import ApiFetch from './ApiFetch.js';
import Dialog from './Dialog.js';
import Footer from './Footer.js';
import Header from './Header.js';
import OnetimePassword from '../domain/OnetimePassword.js';
import CampaignMessage from './CampaignMessage.js';
import Category from './Category.js';
import R18DisplayFlag from '../domain/R18DisplayFlag.js';
import R18GDisplayFlag from '../domain/R18GDisplayFlag.js';
import DisplayId from '../domain/DisplayId.js';
import GitHubId from '../domain/GitHubId.js';
import HuggingFaceId from '../domain/HuggingFaceId.js';
import { useTranslation } from "react-i18next";
import { isLoggin } from '../service/LoginService.js';
import SexualExpressionDisplayFlag from '../domain/PG12DisplayFlag.js';
import Language from '../domain/Language.js';
import * as Icon from 'react-bootstrap-icons';
import Thumb from './common/Thumb.js';
import Cropper from 'react-easy-crop';
import MuiButton from '@mui/material/Button'
import CommonDialog from './common/CommonDialog.js';
import LoadingButton from '@mui/lab/LoadingButton';
import { Alert } from '@mui/material';

const PlanManage = (props) => {
    async function getUserInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserSetting(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    // planIdがあれば更新、なければ新規
    async function update(planId,name,description,amount,ageLimit,planImage,dialog){
        // 必須・文字数・パターン
        if(name.length === 0){
            dialog(t("common.error"),"プラン名を設定してください。")
            return
        }
        if(name.length > 100){
            dialog(t("common.error"),"プラン名は100文字までにしてください。")
            return
        }
        if(description.length === 0){
            dialog(t("common.error"),"概要を入力してください。")
            return
        }
        if(description.length > 2000){
            dialog(t("common.error"),"概要は2000文字までにしてください。")
            return
        }
        if(amount.length === 0 || parseInt(amount.value) < 500 || parseInt(amount.value) > 50000){
            dialog(t("common.error"),"金額は500円～50,000円の範囲にしてください。")
            return
        }
        if(planImage === ""){
            dialog(t("common.error"),"サムネイルを設定してください。")
            return
        }
        setLoading(true)
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/plan/",
            {planId:planId,name:name,description:description,amount:amount,
                ageLimit:ageLimit,planImage:planImage}).then((r)=>{
            return r.json().then((json)=>{
                return json
            })
        })
    }
    async function getImage(page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/my/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getPlanInfo(planId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/plan/basicInfoById/"+planId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deletePlanInfo(planId){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/plan/",{planId:planId}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    // ナビゲート
    const navigate = useNavigate()

    const param = useParams()

    const [oneTimePasswordSended, setOneTimePasswordSended] = useState(false)
    const [planImage, setPlanImage] = useState("")
    const [srcImage, setSrcImage] = useState("")

    const [imageList,setImageList] = useState([])
    const [imagePage,setImagePage] = useState(1)
    const [planInfo,setPlanInfo] = useState([])
    const [seriesDetail,setSeriesDetail] = useState([])
    const [planId,setPlanId] = useState("")
    const [planDeleteConfirm,setPlanDeleteConfirm] = useState(false)

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // フラグ：AI生成作品を表示する
    const [sexualExpressionValue, setSexualExpressionValue] = useState('2');// 性的表現(軽微)
    const [r18Value, setR18Value] = useState('2');
    const [r18GValue, setR18GValue] = useState('2');
    const [userInfo, setUserInfo] = useState([]);
    const [userSetting, setUserSetting] = useState([]);
    const [ageLimit, setAgeLimit] = useState(1);
    const [language, setLanguage] = useState(1);

    const [mode, setMode] = useState("new")
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")

    // 初期処理
    useEffect(() => {
        // 動作モード判定
        if(param.id === "new"){
            setMode("new")
        } else {
            setMode("edit")
        }
        // タイトル設定
        //document.querySelector("title").textContent = t("category.setting") + " - アワートAI"
        getUserInfo().then(r=>{
            setUserInfo(r)
        })
        getUserSetting().then(r=>{
            setUserSetting(r)
            setSexualExpressionValue(String(r.data.sexual_expression_display_flag))
            setR18Value(String(r.data.r18_display_flag))
            setR18GValue(String(r.data.r18g_display_flag))
            setLanguage(String(r.data.language))
        })
        if(param.id !== "new"){
            setPlanId(param.id)
            // 既存のデータを編集するモード
            getPlanInfo(param.id).then(r => {
                if(r.result){
                    setPlanInfo(r.data)
                    setAgeLimit(String(r.data.age_limit))
                } else {
                    dialog(t("common.error"),r.errors)
                }
            })
        }
    },[])

    useEffect(() => {
        // 画像が設定されている場合
        if(planImage.startsWith("data:image/jpeg")){
            console.log("読み込み完了")
        }
    },[planImage])

    // ログイン情報が取得出来たらプロフィール画像に設定
    useEffect(() => {
        if(loginInfo.result === false){
            navigate("/")
        }
    },[loginInfo])

    useEffect(() => {
        if(planInfo.plan_id !== undefined)
        setPlanImage("//"+ApiFetch.IMG_HOST+"/plan/"+planInfo.plan_id+".webp?"+planInfo.update_datetime)
    },[planInfo])

    document.onkeydown = (e) => {
        if(e.key === "Escape"){
            props.switch(false)
        }
    }

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [showCropper,setShowCropper] = useState()
    const [cropTarget,setCropTarget] = useState()
    const [tempThumbnail,setTempThumbnail] = useState()
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
            let image = document.getElementById("load-image")
            let canvas = document.createElement("canvas")
            let ctx = canvas.getContext("2d")
            canvas.width = image.width
            canvas.height = image.height

            ctx.drawImage(image,0,0)

            const data = ctx.getImageData(croppedAreaPixels.x,croppedAreaPixels.y,croppedAreaPixels.width,croppedAreaPixels.height)

            canvas.width = croppedAreaPixels.width
            canvas.height = croppedAreaPixels.height

            ctx.putImageData(data,0,0)

            let thumb = canvas.toDataURL("image/png")

            setTempThumbnail(thumb)
      }, [])

    return (
        <div style={{backgroundColor:"#EEEEEE"}}>
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category /> 
        <Container fluid className='d-flex justify-content-center' style={{marginTop:"60px", backgroundColor:"#EEEEEE", minHeight:"100vh"}}>
        <Row className='w-100 justify-content-center'>
            <Col xs={12} sm={10} md={8} lg={6} xl={6} style={{backgroundColor:"#FFFFFF", borderRadius:"10px", boxShadow:"0 2px 10px rgba(0,0,0,0.1)"}} className='p-4 my-3'>
                <div className='text-center mb-4'>
                    <h3 className='mb-3' style={{color:"#333", fontWeight:"600"}}>{mode === "new" ? "プラン作成" : "プラン編集"}</h3>
                    {loginInfo.id_auth === 0 ? (
                        <Alert severity='info' className='mb-4'>
                            支援機能の利用には振込先口座設定と本人確認、SMS認証が必要です。<br /><br />
                            <MuiButton variant='outlined' onClick={() => navigate("/manage/payouts")}>設定する</MuiButton>
                        </Alert>
                    ) : ""}
                </div>
                    <div className='mb-4' style={{textAlign:"center"}}>
                        <div className='mb-3'>
                            <h6 style={{color:"#666", marginBottom:"15px"}}>サムネイル画像 (2:1比率)</h6>
                            {planImage === "" ? (
                                <div onClick={(e) => document.getElementById("file").click()} 
                                     style={{
                                         width:"100%", 
                                         maxWidth:"400px", 
                                         height:"200px", 
                                         border:"2px dashed #ddd", 
                                         borderRadius:"10px",
                                         cursor:"pointer",
                                         display:"flex",
                                         alignItems:"center",
                                         justifyContent:"center",
                                         backgroundColor:"#f8f9fa",
                                         margin:"0 auto",
                                         transition:"all 0.3s ease"
                                     }}
                                     onMouseOver={(e) => e.currentTarget.style.borderColor = "#007bff"}
                                     onMouseOut={(e) => e.currentTarget.style.borderColor = "#ddd"}>
                                    <div style={{textAlign:"center", color:"#666"}}>
                                        <Icon.PlusCircle size={40} className='mb-2' />
                                        <div>画像をアップロード</div>
                                        <small>2:1の比率で表示されます</small>
                                    </div>
                                </div>
                            ) : (
                                <div style={{position:"relative", display:"inline-block"}}>
                                    <Image 
                                        src={planImage} 
                                        style={{
                                            width:"100%", 
                                            maxWidth:"400px", 
                                            height:"200px", 
                                            borderRadius:"10px",
                                            objectFit:"cover",
                                            boxShadow:"0 2px 8px rgba(0,0,0,0.1)"
                                        }} 
                                    />
                                    <CloseButton 
                                        style={{
                                            position:"absolute", 
                                            top:"10px", 
                                            right:"10px",
                                            backgroundColor:"rgba(255,255,255,0.9)",
                                            borderRadius:"50%"
                                        }}
                                        onClick={(e) => {
                                            document.getElementById("file").value = ""
                                            setPlanImage("")
                                            setSrcImage("")
                                        }} 
                                    />
                                </div>
                            )}
                        </div>
                        <Image src={srcImage} id="load-image" style={{display:"none"}} />
                        <Form.Control type="file" accept=".jpg,.jpeg,.gif,.png,.webp" className='d-none' id="file" onChange={(e) => {
                            setShowCropper(true)
                            ImageUtil.loadImageBig(e.currentTarget.files,setSrcImage,false)
                            document.getElementById("file").value = ""
                        }} />
                    </div>
                    {showCropper ? (
                        <div style={{
                            position:"fixed",
                            top:0,
                            left:0,
                            width:"100%",
                            height:"100%",
                            backgroundColor:"rgba(0,0,0,0.8)",
                            zIndex:9999,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"center"
                        }}>
                            <div style={{
                                position:"relative",
                                width:"90vw",
                                height:"70vh",
                                maxWidth:"800px",
                                backgroundColor:"white",
                                borderRadius:"10px",
                                overflow:"hidden"
                            }}>
                                <div style={{
                                    position:"absolute",
                                    top:0,
                                    left:0,
                                    width:"100%",
                                    height:"100%",
                                    zIndex:1
                                }}>
                                    <Cropper
                                        image={srcImage}
                                        crop={crop}
                                        zoom={zoom}
                                        aspect={2 / 1}
                                        onCropChange={setCrop}
                                        onCropComplete={onCropComplete}
                                        onZoomChange={setZoom}
                                        style={{
                                            containerStyle: {
                                                zIndex: 1
                                            }
                                        }}
                                    />
                                </div>
                                <div style={{
                                    position:"absolute",
                                    bottom:"20px",
                                    left:"50%",
                                    transform:"translateX(-50%)",
                                    width:"300px",
                                    padding:"20px",
                                    backgroundColor:"rgba(255,255,255,0.98)",
                                    borderRadius:"10px",
                                    boxShadow:"0 4px 12px rgba(0,0,0,0.3)",
                                    zIndex:9999999,
                                    border:"2px solid #fff"
                                }}>
                                    <div className="mb-3">
                                        <small style={{color:"#666"}}>ズーム調整</small>
                                        <Form.Range 
                                            value={zoom} 
                                            min={1} 
                                            max={5} 
                                            step={0.1} 
                                            onChange={(e) => setZoom(parseFloat(e.currentTarget.value))} 
                                            style={{
                                                zIndex:9999999,
                                                position:"relative"
                                            }}
                                        />
                                    </div>
                                    <div className="d-flex justify-content-between gap-2">
                                        <MuiButton 
                                            variant="contained" 
                                            size="small"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                e.stopPropagation()
                                                setPlanImage(tempThumbnail)
                                                setShowCropper(false)
                                            }}
                                            style={{
                                                zIndex:9999999,
                                                position:"relative",
                                                pointerEvents:"auto"
                                            }}
                                        >
                                            決定
                                        </MuiButton>
                                        <MuiButton 
                                            variant="outlined" 
                                            size="small"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                e.stopPropagation()
                                                setShowCropper(false)
                                            }}
                                            style={{
                                                zIndex:9999999,
                                                position:"relative",
                                                pointerEvents:"auto"
                                            }}
                                        >
                                            キャンセル
                                        </MuiButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : ""}
                    <div className="mb-4">
                        <FloatingLabel controlId="name" label={<>プラン名 <span className='required'>必須</span></>} className="mb-3">
                            <Form.Control 
                                type="text" 
                                defaultValue={planInfo.name} 
                                style={{borderRadius:"8px", border:"2px solid #e9ecef"}}
                                onFocus={(e) => e.currentTarget.style.borderColor = "#007bff"}
                                onBlur={(e) => e.currentTarget.style.borderColor = "#e9ecef"}
                            />
                        </FloatingLabel>
                        
                        {mode === "new" ? (
                            <FloatingLabel controlId="amount" label={<>金額(確定すると変更できません) <span className='required'>必須</span></>} className="mb-3">
                                <Form.Control 
                                    type="number" 
                                    defaultValue={500} 
                                    min={100} 
                                    max={50000} 
                                    style={{borderRadius:"8px", border:"2px solid #e9ecef"}}
                                    onFocus={(e) => e.currentTarget.style.borderColor = "#007bff"}
                                    onBlur={(e) => e.currentTarget.style.borderColor = "#e9ecef"}
                                />
                            </FloatingLabel>
                        ) : (
                            <FloatingLabel controlId="amount" label={<>金額(確定すると変更できません)</>} className="mb-3">
                                <Form.Control 
                                    type="number" 
                                    value={planInfo.amount} 
                                    disabled 
                                    style={{borderRadius:"8px", backgroundColor:"#f8f9fa"}}
                                />
                            </FloatingLabel>
                        )}
                        
                        <FloatingLabel 
                            controlId="description" 
                            label={<>プラン説明 {mode === "new" ? <span className='required'>必須</span> : ""}</>} 
                            style={{lineHeight:"20px"}}
                            onInput={(e) =>{
                                let lineHeight = e.currentTarget.style.lineHeight.replace(/[^0-9.]+/,'')
                                let n = e.nativeEvent.target.value.match(/\n/g)
                                if(n === null){
                                    n = 1
                                } else {
                                    n = n.length + 1
                                }
                                if(n <= 5){
                                    n = 5
                                }
                                e.currentTarget.style.height = lineHeight * n + 30 + "px"
                                document.querySelector(".textarea").style.height = lineHeight * n + 30 + "px"
                            }}
                        >
                            <Form.Control
                                className='textarea'
                                as="textarea"
                                style={{ 
                                    height: '120px', 
                                    borderRadius:"8px", 
                                    border:"2px solid #e9ecef",
                                    resize: "vertical"
                                }}
                                defaultValue={planInfo.description}
                                onFocus={(e) => e.currentTarget.style.borderColor = "#007bff"}
                                onBlur={(e) => e.currentTarget.style.borderColor = "#e9ecef"}
                            />
                        </FloatingLabel>
                    </div>

                    <div className="mb-4">
                        <div className='mb-2'>
                            <h6 style={{color:"#666", marginBottom:"10px"}}>
                                年齢区分・制限(確定すると変更できません) 
                                {mode === "new" ? <span className='required'>必須</span> : ""}
                            </h6>
                            {mode === "new" ? (
                                <Form.Select 
                                    id="age-limit" 
                                    className="mb-3" 
                                    value={ageLimit} 
                                    onChange={(e) => setAgeLimit(e.target.value)}
                                    style={{borderRadius:"8px", border:"2px solid #e9ecef"}}
                                    onFocus={(e) => e.currentTarget.style.borderColor = "#007bff"}
                                    onBlur={(e) => e.currentTarget.style.borderColor = "#e9ecef"}
                                >
                                    <option value="1">{t("common.allAges")}</option>
                                    {loginInfo.pg12_display_flag === 1 ? <option value="2">PG-12</option> : ""}
                                    {loginInfo.r15_display_flag === 1 ? <option value="3">R-15</option> : ""}
                                    {loginInfo.r18_display_flag === 1 ? <option value="4">R-18</option> : ""}
                                    {loginInfo.r18g_display_flag === 1 ? <option value="5">R-18G</option> : ""}
                                </Form.Select>
                            ) : (
                                <Form.Select 
                                    id="age-limit" 
                                    className="mb-3" 
                                    value={ageLimit} 
                                    disabled
                                    style={{borderRadius:"8px", backgroundColor:"#f8f9fa"}}
                                >
                                    <option value="1">{t("common.allAges")}</option>
                                    <option value="2">PG-12</option>
                                    <option value="3">R-15</option>
                                    <option value="4">R-18</option>
                                    <option value="5">R-18G</option>
                                </Form.Select>
                            )}
                        </div>
                    </div>

                    <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center mb-4">
                        <LoadingButton 
                            loading={loading} 
                            variant='contained' 
                            size="large"
                            onClick={() => {
                                update(
                                    planId,
                                    document.getElementById("name").value,
                                    document.getElementById("description").value,
                                    document.getElementById("amount").value,
                                    document.getElementById("age-limit").value,
                                    planImage,
                                    dialog
                                ).then((r)=> {
                                    if(r === undefined) return
                                    if(r.result){
                                        navigate("/user/"+r.data.userIdOrDisplayId+"/plans")
                                    } else {
                                        if(r.errors[0].indexOf("本人確認が必要です") !== -1){
                                            dialog(t("common.error"),<>支援機能の利用には本人確認が必要です。<br /><br /><MuiButton variant='outlined' onClick={() => navigate("/manage/id")}>本人確認する</MuiButton></>)
                                        } else {
                                            dialog(t("common.error"),r.errors)
                                        }
                                    }
                                    setLoading(false)
                                })
                            }} 
                            disabled={loginInfo.id_auth === 0}
                            style={{
                                borderRadius:"8px",
                                padding:"12px 30px",
                                fontSize:"16px",
                                fontWeight:"600"
                            }}
                        >
                            {t("common.update")}
                        </LoadingButton>
                        
                        {mode === "edit" ? (
                            <MuiButton 
                                color='warning' 
                                variant="outlined"
                                size="large"
                                onClick={() => setPlanDeleteConfirm(true)} 
                                disabled={loginInfo.id_auth === 0}
                                style={{
                                    borderRadius:"8px",
                                    padding:"12px 30px",
                                    fontSize:"16px",
                                    fontWeight:"600"
                                }}
                            >
                                プランを削除
                            </MuiButton>
                        ) : ""}
                    </div>
                    <CommonDialog title="確認" open={planDeleteConfirm} content={
                        <div className='text-center'>
                            <div className='mb-4' style={{fontSize:"16px", lineHeight:"1.6"}}>
                                プランを削除しますか？<br />
                                削除するとこのプランへのすべての支援が停止されます。
                            </div>
                            <div className="d-flex gap-2 justify-content-center">
                                <LoadingButton 
                                    loading={loading} 
                                    variant='contained' 
                                    color='warning' 
                                    onClick={() => {
                                        setLoading(true)
                                        deletePlanInfo(planId).then(r => {
                                            if(r.result){
                                                navigate("/user/"+r.data.userIdOrDisplayId+"/plans")
                                            } else {
                                                setErrorMessage(r.errors)
                                            }
                                            setLoading(false)
                                        })
                                    }}
                                    style={{borderRadius:"8px"}}
                                >
                                    削除する
                                </LoadingButton>
                                <MuiButton 
                                    variant="outlined"
                                    onClick={() => setPlanDeleteConfirm(false)}
                                    style={{borderRadius:"8px"}}
                                >
                                    キャンセル
                                </MuiButton>
                            </div>
                            {errorMessage.length > 0 ? (
                                <Alert severity='error' className='mt-3' style={{textAlign:"left"}}>
                                    {errorMessage}
                                </Alert>
                            ) : ""}
                        </div>
                    } onClose={() => {
                        setPlanDeleteConfirm(false)
                    }} />
                </Col>
            </Row>
        </Container>
        <Footer />
        </div>
    )
}

export default PlanManage;
